import { render } from "./type_switch_form_6.vue?vue&type=template&id=f75baadc"
import script from "./type_switch_form_6.vue?vue&type=script&lang=js"
export * from "./type_switch_form_6.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/form-elements/type_switch_form_6.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f75baadc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f75baadc', __exports__)) {
    console.log('reload')
    api.reload('f75baadc', __exports__)
  }
  
  module.hot.accept("./type_switch_form_6.vue?vue&type=template&id=f75baadc", () => {
    console.log('re-render')
    api.rerender('f75baadc', render)
  })

}


export default __exports__